import { api } from './api';

export const eventService = {
    getAllVenues: async () => {
        const response = await api.get('/events/venues');
        return response.data;
    },

    getAllEvents: async () => {
        const response = await api.get('/events');
        return response.data;
    },

    createEvent: async (eventData) => {
        try {
            const response = await api.post('/events', eventData);
            return response.data;
        } catch (error) {
            console.error('eventService.createEvent - Error:', {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                config: {
                    url: error.config?.url,
                    method: error.config?.method,
                    baseURL: error.config?.baseURL,
                    data: error.config?.data
                }
            });
            throw error;
        }
    },

    updateEvent: async (id, eventData) => {
        try {
            const response = await api.put(`/events/${id}`, eventData);
            return response.data;
        } catch (error) {
            console.error('eventService.updateEvent - Error:', error);
            throw error;
        }
    },

    getAllMembers: async () => {
        try {
            const response = await Promise.race([
                api.get('/users/members'),
                new Promise((_, reject) => 
                    setTimeout(() => reject(new Error('Request timeout')), 5000)
                )
            ]);
            return response.data;
        } catch (error) {
            console.error('getAllMembers Error:', {
                message: error.message,
                status: error.response?.status,
                data: error.response?.data,
                config: {
                    url: error.config?.url,
                    baseURL: error.config?.baseURL,
                    headers: error.config?.headers
                }
            });
            if (error.message === 'Network Error') {
                console.error('Network Error Details:', {
                    baseURL: api.defaults.baseURL,
                    withCredentials: api.defaults.withCredentials,
                    headers: api.defaults.headers
                });
            }
            throw error;
        }
    },

    formatDate: (date) => {
        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const dateObj = new Date(date);
        
        return dateObj.toLocaleString('en-AU', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: browserTimeZone
        });
    },

    createVenue: async (venueData) => {
        const response = await api.post('/events/venues', venueData);
        return response.data;
    },

    updateVenue: async (venueId, venueData) => {
        const response = await api.put(`/events/venues/${venueId}`, venueData);
        return response.data;
    },

    deleteVenue: async (venueId) => {
        const response = await api.delete(`/events/venues/${venueId}`);
        return response.data;
    },

    deleteEvent: async (eventId) => {
        const response = await api.delete(`/events/${eventId}`);
        return response.data;
    },

    getEventAttendance: async (eventId) => {
        const response = await api.get(`/events/${eventId}/attendance`);
        return response.data;
    },

    getEventDetails: async (eventId) => {
        try {
            const response = await api.get(`/events/${eventId}/details`);
            return response.data;
        } catch (error) {
            console.error('[Service] Error getting event details:', error);
            throw error;
        }
    },

    updateEventSession: async (eventId, sessionType, sessionData) => {
        const response = await api.put(`/events/${eventId}/session/${sessionType}`, sessionData);
        return response.data;
    },

    getNextMeeting: async (currentEventId) => {
        try {
            const response = await api.get(`/events/${currentEventId}/next`);
            return response.data;
        } catch (error) {
            console.error('Error fetching next meeting:', error);
            return null;
        }
    },

    getMemberSpeakingHistory: async () => {
        try {
            const response = await api.get('/events/member-speaking-history');
            return response.data;
        } catch (error) {
            console.error('Error getting member speaking history:', error);
            throw error;
        }
    },

    getFormats: async () => {
        try {
            const response = await api.get('/meeting-formats');
            return response.data;
        } catch (error) {
            console.error('Error getting meeting formats:', error);
            throw error;
        }
    },

    getMeetingFormats: async () => {
        try {
            const response = await api.get('/meeting-formats');
            return response.data;
        } catch (error) {
            console.error('Error getting meeting formats:', error);
            throw error;
        }
    },

    getSpeakerRoster: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.startDate) queryParams.append('startDate', params.startDate);
            if (params.endDate) queryParams.append('endDate', params.endDate);
            if (params.limit) queryParams.append('limit', params.limit);
            
            const queryString = queryParams.toString();
            const url = `/events/speaker-roster${queryString ? `?${queryString}` : ''}`;
            
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error('Error getting speaker roster:', error);
            throw error;
        }
    }
}; 